
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class TeamService {
    constructor(private http: HttpClient) {}

    saveTeamDetails(eventId, model) {
        return this.http.post('/api/v1/team/changteams/1/1/goal' + eventId, model).pipe(map(res => {
            return res;
        }));
    }

    saveTeamGoal(teamId, participantId, value) {
        return this.http.post('/api/v1/teams/' + teamId + '/' + participantId + '/goal', value).pipe(map(res => {
            return res;
        }));
    }

    saveTeamEdit(teamId, model) {
        return this.http.post('/api/v1/teams/' + teamId, model).pipe(map(res => {
            return res;
        }));
    }
}
